// First path segments the app itself uses (https://site/<name>). A provider's public page lives at /<handle or slug>, so
// none of these can be a provider page. Keep in step with RESERVED_PATHS in backend/auth.py.
export const RESERVED_PATHS = new Set([
  "api", "static", "explore", "activities", "family", "embed", "kiosk", "sign", "invite", "signup", "login", "logout", "register", "billing", "payment",
  "admin", "platform", "settings", "dashboard", "app", "www", "assets", "docs", "help", "about", "contact", "pricing", "providers", "for-providers",
  "terms", "privacy", "legal", "school-it", "policies", "status", "health", "blog", "welcome", "demo", "support", "sitemap", "robots", "manifest", "favicon", "index", "oosh-logo",
]);

// "/sunnybay" -> "sunnybay" when it is a single-segment provider page address, else ""
export const providerPageName = (pathname) => {
  const m = pathname.match(/^\/([a-z0-9][a-z0-9-]{1,38}[a-z0-9])\/?$/i);
  return m && !RESERVED_PATHS.has(m[1].toLowerCase()) ? m[1].toLowerCase() : "";
};
